import Tag from './tag.vue';
export default Tag;



// WEBPACK FOOTER //
// ./src/components/tag/index.js